import React from 'react';
import Shared from 'screens/shared';
import { actions } from 'redux/local';
import { VALIDATION } from 'constant';

export default ({
  isCancel = false,
  onCancel,
}) => {
  const model = {
    name: '',
    location: '',
    size: 1,
  };

  const fields = [
    {
      name: 'name',
      type: 'text',
      title: 'Name',
    },
    {
      name: 'email',
      type: 'text',
      title: 'Email',
    },
    {
      name: 'password',
      type: 'password',
      title: 'Password',
    },
  ];

  const validations = [
    {
      name: 'name',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'name',
      type: VALIDATION.VARIABLE,
    },
    {
      name: 'name',
      type: VALIDATION.STRING,
      max: 255,
    },
    {
      name: 'password',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'password',
      type: VALIDATION.STRING,
      min: 6,
    },
    {
      name: 'email',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'email',
      type: VALIDATION.EMAIL,
    },
  ];

  const onSave = ({
    name, email, password,
  }) => {
    actions.backupUnits.create({ name, email, password });
  };

  return (
    <>
      <Shared.forms.Form
        fields={fields}
        fieldsValues={model}
        onSubmit={onSave}
        isCancel={isCancel}
        onCancel={onCancel}
        validations={validations}
      />
    </>
  );
};
